/*
This action file conatin the action related to payment
*/
import * as api from '../api';

export const ADD_PAYMENT_REQUEST='ADD_PAYMENT_REQUEST';
export const ADD_PAYMENT_FAILURE='ADD_PAYMENT_FAILURE';
export const ADD_PAYMENT_SUCCESS='ADD_PAYMENT_SUCCESS';
export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';


export const ADD_INTENT_PAYMENT_REQUEST='ADD_INTENT_PAYMENT_REQUEST';
export const ADD_INTENT_PAYMENT_FAILURE='ADD_INTENT_PAYMENT_FAILURE';
export const ADD_INTENT_PAYMENT_SUCCESS='ADD_INTENT_PAYMENT_SUCCESS';
export const INTENT_NOTIFICATION_ADD = 'INTENT_NOTIFICATION_ADD';
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
export const INTENT_PAYMENT_RESET = 'INTENT_PAYMENT_RESET';

export function paymentRequest(token){
	return function(dispatch, getState){
	    dispatch({
	      type: ADD_PAYMENT_REQUEST
	    });
	    api.paymentRequest(token).then(
	    	(response) => {
		        dispatch({
		          type: ADD_PAYMENT_SUCCESS,
		          payment: response
		        });
		        dispatch({
		          type: 'NOTIFICATION_ADD',
		          text: 'Payment is successfull. Please select your manuals.',
		          msgtype: 'success'
		        });
		      },
		      (error) => {
		        dispatch({
		          type: ADD_PAYMENT_FAILURE,
		          error: error,
		          message: error.message || 'Could not complete Payment request.'
		        });
		        if(error.then){
          
	          		error.then((json)=>{
				        dispatch({
				          type: NOTIFICATION_ADD,
				          text: json.message || 'Could not complete payment request. Please try again.',
				          msgtype: 'danger'
				        });
				    });
				}else{
					dispatch({
			          type: NOTIFICATION_ADD,
			          text: error.message || 'Could not complete payment request. Please try again.',
			          msgtype: 'danger'
			        });
				}
		      }
	    );
	};
};

export function createPaymentIntent(data){
	return function(dispatch, getState){
	    dispatch({
	      type: ADD_INTENT_PAYMENT_REQUEST
	    });
	    api.createPaymentIntent(data).then(
	    	(response) => {
		        dispatch({
		          type: ADD_INTENT_PAYMENT_SUCCESS,
		          payment: response
		        });
		        // dispatch({
		        //   type: 'INTENT_NOTIFICATION_ADD',
		        //   text: 'Payment is successfull. Please select your manuals.',
		        //   msgtype: 'success'
		        // });
		      },
		      (error) => {
				//   console.log(error);
		        dispatch({
		          type: ADD_INTENT_PAYMENT_FAILURE,
		          error: error,
		          message: error.message || 'Could not complete Payment request.'
		        });
		        if(error.then){
          
	          		error.then((json)=>{
				        dispatch({
				          type: NOTIFICATION_ADD,
				          text: json.message || 'Could not complete payment request. Please try again.',
				          msgtype: 'danger'
				        });
				    });
				}else{
					dispatch({
			          type: NOTIFICATION_ADD,
			          text: error.message || 'Could not complete payment request. Please try again.',
			          msgtype: 'danger'
			        });
				}
		      }
	    );
	};
};



export function requestStartError(){
	return function(dispatch, getState){
	    dispatch({
	      type: "SUBSCRIPTION/CREATEPAYMENTINTENT/ERROR"
		});
		// dispatch ({type:"SUBSCRIPTION/CREATEPAYMENTINTENT/ERROR"})
	};
};

export function createPaymentIntentReset(){
	return function(dispatch, getState){
	    dispatch({
			type: INTENT_PAYMENT_RESET
		});
	};
}
export function paymentSuccess(){
	return function(dispatch, getState){
	    dispatch({
			type: PAYMENT_SUCCESS
		});
	};
}

export const TOGGLE_TNC_SIGNUP='TOGGLE_TNC_SIGNUP';

export function setTncText(text){
	return {
		type:TOGGLE_TNC_SIGNUP,
		text:text
	};
}

export function modalCancelHandlerStripe(setup_intent_id, client_secret){
	return function (dispatch, getState){
		api.modalCancelHandlerStripe(setup_intent_id, client_secret).then(
			(response) => {
				// console.log(response)
			},
			(error) =>{
				// console.log(error)
			}
		)
	}

}





// WEBPACK FOOTER //
// ./src/Actions/payment.js